import { MRT_ColumnDef, MRT_RowData } from 'mantine-react-table';
import { NOTES_MIN_SIZE } from '../../components/QueueTable';
import { StickyNoteCell } from '../../services/listRowShared';
import { NoteCell, NoteCellProps } from './NoteCell';

/** The patient's latest sticky note, editable from the row. Notes is the one column that grows. */

interface NotesRowLike extends MRT_RowData {
  patient?: { id?: string };
  stickyNote?: StickyNoteCell;
}

export function notesColumn<Row extends NotesRowLike>({
  onSaved,
  minSize = NOTES_MIN_SIZE,
}: Pick<NoteCellProps, 'onSaved'> & {
  /** The floor it grows from: the Coverage tabs' case notes get 320 (BAR-3097). */
  minSize?: number;
}): MRT_ColumnDef<Row> {
  return {
    id: 'notes',
    header: 'Notes',
    size: minSize,
    grow: true,
    enableSorting: false,
    Cell: ({ row }) => (
      <NoteCell patientId={row.original?.patient?.id} note={row.original?.stickyNote} onSaved={onSaved} />
    ),
  };
}
